export default __webpack_public_path__ + "static/media/61769bdb69313308ca83b6f23b41a1451577717472098.dedd5fcb.webp";